
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AppointmentQueues',
  data () {
    return {
      appointmentDate: new Date().toISOString().substr(0, 10)
    }
  }
})
